import {memo} from "react";

export const SubtractIcon = memo(({className, ...props}) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M18 11.25H6V12.75H18V11.25Z" fill="currentColor" />
    </svg>
  );
});

SubtractIcon.displayName = "SubtractIcon";
